import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  liveLessonsData: [],
  totalliveLessons: 0,
  isOpenModal: false,
}

export const liveLessonsSlice = createSlice({
  name: "liveLessons",
  initialState,
  reducers: {
    setliveLessonsData(state, { payload }) {
      state.liveLessonsData = payload.result
      state.totalliveLessons = payload.count
    },
    updateliveLessonsData(state, { payload }) {
      const objIndex = state.liveLessonsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.liveLessonsData[objIndex] = payload
      }
    },
    deleteliveLessonsData(state, { payload }) {
      const objIndex = state.liveLessonsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.liveLessonsData.splice(objIndex, 1)
      }
    },
    pushliveLessonsData(state, { payload }) {
      state.liveLessonsData.push(payload)
      state.totalliveLessons += 1
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setliveLessonsData, updateliveLessonsData, deleteliveLessonsData, pushliveLessonsData, isOpenModal,
  ModalToggle } = liveLessonsSlice.actions;

export default liveLessonsSlice.reducer;

export function getliveLessons(limit, offset, status, keyword) {
  return async function getliveLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getliveLessons(limit, offset, status, keyword).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setliveLessonsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addliveLessons(payload) {
  return async function addliveLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addliveLessons(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushliveLessonsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateliveLessons(id, data) {
  return async function updateliveLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateliveLessons(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateliveLessonsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function deleteLiveLessons(id) {
  return async function deleteLiveLessonsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteLiveLessons(id).then(
        (response) => {
          dispatch(deleteliveLessonsData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



